import { apiCall } from "./servicesCall";

export const EXPLORE_SERVICES = {
  list(data) {
    return apiCall("/explore/list", data);
  },
};
